import script from "./Basic.vue?vue&type=script&setup=true&lang=js"
export * from "./Basic.vue?vue&type=script&setup=true&lang=js"

import "./Basic.vue?vue&type=style&index=0&id=57557b2c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57557b2c"]])

export default __exports__